import Cookies from 'js-cookie'
import { profileSub } from './subscription'
import { CommonContext } from '@ssr/context'
import React from 'react'

function printEnv() {
  console.log('[dev] insta_app_name:', Cookies.get('insta_app_name'))
  console.log('[dev] insta_app_version:', Cookies.get('insta_app_version'))
  console.log('[dev] insta_app_language:', Cookies.get('insta_app_language'))
  console.log('[dev] insta_app_last_connect_camera_type:', Cookies.get('insta_app_last_connect_camera_type'))
  console.log('[dev] insta_app_local_id:', Cookies.get('insta_app_local_id'))
}

function identify() {
  function setTracking(userId) {
    window.gtm_global_user_id = userId
  }

  function setUserId(email) {
    if (email) {
      const userId = `official ${btoa(email)}`

      setTracking(userId)
    } else {
      let anonymousUserId = Cookies.get('insta_anonymous_user_id')

      if (anonymousUserId) {
        setTracking(anonymousUserId)
      }
    }
  }

  profileSub.fetch((profile) => {
    setUserId(profile && profile.email)
  })
}

export default function Init() {
  const { metaData, __ } = React.useContext(CommonContext)
  const { isDev } = metaData

  React.useEffect(() => {
    if (isDev) {
      printEnv()
    }
    window.afterGAInit = function () {
      identify()
    }
  }, [])
  return (
    <>
      {/* Dev调试 */}
      {isDev ? (
        <>
          <script src='https://res.insta360.com/static/0cf677a579f071a02806bb7bbe5cc733/eruda.min.js'></script>
          <script>eruda.init();</script>
        </>
      ) : null}
    </>
  )
}
